import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { ModalCard, TextField } from '@datapad/common-controls';
import { AppContext, Player } from '@datapad/data-model';
import { assertNotUndefined } from '@datapad/utilities';
import { useTree } from '@fluidframework/react/alpha';
import { Delete } from '@mui/icons-material';
import { Box, Button, CardActions, CardContent, IconButton, Table, TableBody, TableCell, TableRow, Tooltip, Typography, } from '@mui/material';
import { Tree } from 'fluid-framework';
import React from 'react';
import { CharacterList } from './CharacterList.js';
var ModalStatus;
(function (ModalStatus) {
    ModalStatus[ModalStatus["None"] = 0] = "None";
    ModalStatus[ModalStatus["Deleting"] = 1] = "Deleting";
})(ModalStatus || (ModalStatus = {}));
export function PlayerView(props) {
    const { player } = props;
    useTree(player);
    const [modalStatus, setModalStatus] = React.useState(ModalStatus.None);
    const { getUsersCharacters, handleCharacterLink } = assertNotUndefined(React.useContext(AppContext));
    const characters = getUsersCharacters(player);
    const maybeModal = (_jsx(EditingModal, { modalStatus: modalStatus, user: player, closeModal: () => setModalStatus(ModalStatus.None), deletePlayer: () => {
            props.deletePlayer();
            setModalStatus(ModalStatus.None);
        } }));
    return (_jsxs(_Fragment, { children: [maybeModal, _jsxs(Box, { sx: {
                    maxWidth: 600,
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                }, children: [_jsx(Table, { sx: { width: '100%' }, children: _jsxs(TableBody, { children: [_jsxs(TableRow, { children: [_jsx(TableCell, { children: _jsx(Typography, { variant: "body1", children: _jsx("b", { children: "User Name" }) }) }), _jsx(TableCell, { children: _jsx(TextField, { value: player.userName, onChange: (value) => (player.userName = value) }) })] }), _jsxs(TableRow, { children: [_jsx(TableCell, { children: _jsx(Typography, { variant: "body1", children: _jsx("b", { children: "Characters" }) }) }), _jsx(TableCell, { children: Tree.is(player, Player) && (_jsx(CharacterList, { characters: characters, onClick: handleCharacterLink, defaultCharacterId: 'defaultCharacter' in player
                                                    ? player.defaultCharacter?.id
                                                    : undefined, changeDefaultCharacter: (newDefaultCharacter) => (player.defaultCharacter = newDefaultCharacter) })) })] })] }) }), _jsx(Box, { sx: {
                            width: '100%',
                            display: 'flex',
                            flexDirection: 'row-reverse',
                        }, children: _jsx(Box, { id: "profile-toolbar-buttons", sx: {
                                display: 'flex',
                                flexDirection: 'row',
                            }, children: _jsx(Tooltip, { title: "Delete player", children: _jsx(IconButton, { onClick: () => {
                                        setModalStatus(ModalStatus.Deleting);
                                    }, children: _jsx(Delete, {}) }) }) }) })] })] }));
}
function EditingModal(props) {
    const { modalStatus, user, closeModal, deletePlayer } = props;
    let renderedDialogue;
    switch (modalStatus) {
        case ModalStatus.None:
            renderedDialogue = undefined;
            break;
        case ModalStatus.Deleting:
            renderedDialogue = (_jsx(ModalCard, { open: true, children: _jsxs(_Fragment, { children: [_jsxs(CardContent, { children: [_jsx(Typography, { variant: "body1", children: `Are you sure you wish to delete player "${user.userName}"?` }), _jsx("br", {}), _jsx(Typography, { variant: "body2", children: `Note that this action cannot be undone.` })] }), _jsx(CardActions, { children: _jsxs(Box, { sx: {
                                    width: '100%',
                                    display: 'flex',
                                    flexDirection: 'row',
                                    justifyContent: 'space-between',
                                }, children: [_jsx(Tooltip, { title: "Confirm", children: _jsx(Button, { color: "primary", onClick: deletePlayer, children: "Confirm" }) }), _jsx(Tooltip, { title: "Cancel", children: _jsx(Button, { color: "secondary", onClick: closeModal, children: "Cancel" }) })] }) })] }) }));
            break;
        default:
            throw new Error(`Unrecognized ModalStatus value: "${modalStatus}".`);
    }
    if (renderedDialogue === undefined) {
        return _jsx(_Fragment, {});
    }
    else {
        return (_jsx(ModalCard, { open: true, onClose: closeModal, children: renderedDialogue }));
    }
}
//# sourceMappingURL=PlayerView.js.map